import { OperationRequestData } from "../../data/operationRequestData";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { OperationModel } from "../../models/operations/operationModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { OperationsApi } from "../api/OperationsApi";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import BaseOperationService from "./BaseOperationService";
import { RequestsStates } from "../../data/enums/requestsStates";

/**Сервис проведения операций */
@injectable()
export default class AnonymousOperationService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  /**
   * Обработка prepare
   * @param actionModel Данные операции
   */
  public async prepare(actionModel: OperationModel): Promise<OperationModel> {
    try {
      let ord: OperationRequestData = actionModel.createOperationRequest();
      ord = await OperationsApi.prepareAnonymousOperationSendAsync(ord);
      actionModel.setOperationFromRequest(ord);
      actionModel.OperationId = ord.operationId;
      actionModel._actionState = ActionStateEnum.Confirm;
      actionModel._isNeedConfirm = ord.needConfirm;
    } catch (e) {
      actionModel.ActionStateText = e.message;
      throw e;
    }
    return actionModel;
  }
  /**
   * Обработка execute
   * @param actionModel Данные операции
   */
  public async execute(actionModel: OperationModel): Promise<OperationModel> {
    try {
      let ord: OperationRequestData = actionModel.createOperationRequest();
      ord.verificationCode = actionModel.VerifyCode;
      ord.operationId = actionModel.OperationId;
      ord = await OperationsApi.executeAnonymousOperationSendAsync(ord);
      actionModel.setOperationFromRequest(ord);
      actionModel.RequestState = ord.requestState;
      actionModel = await this.analyzeState(actionModel, ord);
    } catch (e) {
      actionModel.ActionStateText = e.message;
      throw e;
    }
    return actionModel;
  }

  /**Вычисляем статус операции после выполнения */
  public async analyzeState(
    model: OperationModel,
    ord: OperationRequestData
  ): Promise<OperationModel> {
    model._actionState =
      ord.requestState == RequestsStates.Executed ||
        ord.requestState == RequestsStates.None
        ? ActionStateEnum.Success
        : [3, 6, 7].indexOf(ord.requestState as number)
          ? ActionStateEnum.Error
          : ActionStateEnum.Executing;
    model.ActionStateText = ord.requestStateDescription;
    return model;
  }
}
